import { isBoolean as t } from "../../utils/types.js";
const o = {
  modelValue: {
    type: Boolean,
    default: !1
  },
  title: {
    type: String,
    default: ""
  },
  width: {
    type: [String, Number]
  },
  destroyOnClose: {
    type: Boolean,
    default: !1
  },
  dialogClass: {
    type: String,
    default: ""
  },
  closeOnClickOverlay: {
    type: Boolean,
    default: !0
  },
  zIndex: {
    type: Number
  },
  modal: {
    type: Boolean,
    default: !0
  },
  modalClass: String,
  customClass: {
    type: String,
    default: ""
  },
  showClose: {
    type: Boolean,
    default: !0
  },
  draggable: {
    type: Boolean,
    default: !1
  },
  appendToBody: {
    type: Boolean,
    default: !0
  }
}, a = {
  open: () => !0,
  opened: () => !0,
  close: () => !0,
  closed: () => !0,
  "update:modelValue": (e) => t(e)
};
export {
  a as dialogEmits,
  o as dialogProps
};
